import React from 'react';
export function Footer() {
  return <footer className="bg-ink border-t border-white/10 px-4 sm:px-6 py-8 text-center" data-id="element-60" data-mp="32wd2qgad7ltj">
      <div className="max-w-2xl mx-auto" data-id="element-61" data-mp="3gg0xbxz0nnv0">
        <p className="font-heading font-extrabold uppercase text-sm sm:text-lg tracking-tight text-white mb-2" data-id="element-62" data-mp="32nul2myzi10u">
          Fitness Senior Ready™
        </p>

        <p className="text-[12px] sm:text-sm text-white/60 leading-relaxed mb-1" data-id="element-63" data-mp="36pzblcu4yhj9">
          Stop rebuilding your senior fitness programming from scratch.
        </p>
        <p className="font-heading font-semibold text-[10px] sm:text-xs uppercase tracking-[0.12em] text-lime mb-5" data-id="element-64" data-mp="39904ifsbca6">
          Plan faster. Adapt confidently. Coach with structure.
        </p>

        <p className="text-[10px] sm:text-[11px] text-white/40 leading-relaxed max-w-xl mx-auto mb-4" data-id="element-65" data-mp="3qcxawi3rv06f">
          © {new Date().getFullYear()} Fitness Senior Ready™ — All Rights
          Reserved. The resources are intended to support professional fitness
          planning and organization. They do not replace appropriate
          qualifications, individualized assessment, applicable professional
          guidance, or the coach's professional judgment.
        </p>

        <nav className="flex justify-center gap-3 sm:gap-5 font-heading font-bold uppercase text-[9px] sm:text-[10px] tracking-[0.12em] text-white/50" data-id="element-66" data-mp="3gctr8txpeztz">
          <a href="#" className="hover:text-lime transition-colors duration-150" data-id="element-67" data-mp="3q7u1bojhypzf">
            Terms
          </a>
          <span aria-hidden="true" data-id="element-68" data-mp="81fq3xcm4u4q">·</span>
          <a href="#" className="hover:text-lime transition-colors duration-150" data-id="element-69" data-mp="33xgs5uoocw7">
            Privacy
          </a>
          <span aria-hidden="true" data-id="element-70" data-mp="htd0x2zplk2x">·</span>
          <a href="#" className="hover:text-lime transition-colors duration-150" data-id="element-71" data-mp="hs1yb6i02ide">
            Contact
          </a>
        </nav>
      </div>
    </footer>;
}